import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ToolbarOptions } from '../StudyListToolbar';
import {
  StudyListSidebar,
  StudyListSidebarSharedProps,
} from './StudyListSidebar';
import { SortAndFilterSidebarContent } from './SortAndFilterSidebarContent';
import type { FilterSortDisplayForm } from './useFilterSortDisplayForm';
import { useTags } from 'hooks/reviews/useTags';

type Props = StudyListSidebarSharedProps & {
  disclosureId: string;
  form: UseFormReturn<FilterSortDisplayForm>;
  sortOptions: Record<string, string>;
  isAwaitingOtherReviewer: boolean;
  reviewStage: ToolbarOptions['reviewStage'];
  isResetting: boolean;
  onApply: (values: FilterSortDisplayForm) => Promise<void>;
  onReset: () => Promise<void>;
};

export const SortAndFilterSidebar = ({
  disclosureId,
  form,
  sortOptions,
  isAwaitingOtherReviewer,
  reviewStage,
  isResetting,
  onApply,
  onReset,
  ...sidebarProps
}: Props) => {
  const { tags } = useTags();

  const applyThenClose = async (values: FilterSortDisplayForm) => {
    await onApply(values);
    sidebarProps.onClose();
  };

  return (
    <StudyListSidebar
      {...sidebarProps}
      closeButtonLabel="Close sort and filter"
      disclosureId={disclosureId}
      title="Sort & Filter"
      hasHeaderDivider
    >
      <SortAndFilterSidebarContent
        form={form}
        sortOptions={sortOptions}
        tags={tags.map((tag) => tag.name)}
        isAwaitingOtherReviewer={isAwaitingOtherReviewer}
        reviewStage={reviewStage}
        isResetting={isResetting}
        onApply={applyThenClose}
        onReset={onReset}
      />
    </StudyListSidebar>
  );
};
